import React from 'react';
import ComingSoonSVG from '../../styles/assets/images/coming-soon';

const BlogDashboard = () => (
  <div className="main-blog__section">
    <ComingSoonSVG />
    <p className="main-blog__section-header">Coming soon</p>
  </div>
);

export default BlogDashboard;
